import type React from "react";
import { ReactComponent as Svg } from "./assets/location.svg";
import * as styles from "./Icon.module.scss";

type LocationProps = React.SVGProps<SVGSVGElement>;

export const Location = ({ className, ...props }: LocationProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
